import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useHome } from "@/i18n/home";

const PILLARS = [
  {
    img: "/services/pillar-wifi.jpg",
    t: "WLAN-Systeme",
    d: "Kein Funkloch. Nirgends.",
    main: true,
    points: ["UniFi-Profi-WLAN", "Nahtloses Roaming", "Gäste- & Betriebsnetz getrennt"],
  },
  {
    img: "/services/pillar-cctv.jpg",
    t: "Videoüberwachung",
    d: "Alles im Blick. Tag & Nacht.",
    points: ["4K-Kameras & Nachtsicht", "Live-Zugriff per App", "Smarte Bewegungserkennung"],
  },
  {
    img: "/services/pillar-sat.jpg",
    t: "TV-/SAT-Anlagen",
    d: "Bestes Bild in jedem Zimmer.",
    points: ["SAT-Verteilung & Multiswitch", "Sortierte Senderlisten", "Ideal für Hotels"],
  },
];

export const Pillars = () => {
  const ph = useHome().pillars;
  const items = PILLARS.map((p, i) => ({ ...p, ...ph.items[i] }));
  return (
  <section id="services" className="relative overflow-hidden bg-[#F7F8FA] py-24 sm:py-28" data-testid="pillars">
    {/* airy brand glows */}

    <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-3xl mb-14">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0B87B0]">
          {ph.overline}
        </span>
        <h2 className="mt-6 font-display font-semibold tracking-tight text-4xl sm:text-5xl leading-[1.04] text-[#090A0C]">
          {ph.title}
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {items.map((p, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`pillar-${i}`}
            className={`group relative flex flex-col rounded-[2rem] border bg-white p-8 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_16px_40px_rgba(0,0,0,0.08)] ${p.main ? "border-[#00C3FF] shadow-[0_16px_40px_rgba(0,195,255,0.14)] md:-translate-y-3" : "border-[#E5E7EB] shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:border-[#00C3FF]/40"}`}
          >
            {p.main && (
              <span className="absolute -top-3.5 left-8 rounded-full bg-[#FF7A00] px-4 py-1 text-[11px] font-bold uppercase tracking-[0.18em] text-white" data-testid="pillar-specialty-badge">
                {ph.badge}
              </span>
            )}
            <div className="relative -mx-3 -mt-3 mb-7 aspect-[3/2] overflow-hidden rounded-[1.5rem] bg-[#0A0E13]" data-testid={`pillar-image-${i}`}>
              <img src={`${p.img}?v=2`} alt={p.t} loading="lazy" className="pt-float-wrap h-full w-full object-cover" />
              <span className="pointer-events-none absolute inset-0 opacity-0 mix-blend-screen transition-opacity duration-500 group-hover:opacity-100" style={{ background: "radial-gradient(ellipse 55% 50% at 50% 45%, rgba(0,195,255,0.35), transparent 70%)" }} aria-hidden="true" />
            </div>
            <h3 className="mt-1 font-display text-2xl font-bold text-[#090A0C]">{p.t}</h3>
            <p className="mt-1.5 text-[15px] font-medium text-[#0B87B0]">{p.d}</p>
            <ul className="mt-7 space-y-3.5 border-t border-[#D3E2EC] pt-7">
              {p.points.map((pt, j) => (
                <li key={j} className="flex items-start gap-3 text-[15px] text-[#374151]">
                  <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full" style={{ background: "rgba(255,122,0,0.20)" }}>
                    <Check size={13} color="var(--pt-orange)" strokeWidth={3} />
                  </span>
                  {pt}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
  );
};
